import { EnvironmentUtil } from "services/util/EnvironmentUtil";
import { ApiVersion } from "./ApiVersion";

export const getApiUrl = (url: string, version: ApiVersion) =>
  (version === ApiVersion.V2) ? EnvironmentUtil.apiV2Url(url) : (version === ApiVersion.V3) ? EnvironmentUtil.apiV3Url(url) : EnvironmentUtil.apiV1Url(url);
